/* Tin Yat Dragon — CNY Guide (slideable)
   - Scroll-snap slider controls (dots + prev/next)
   - Optional “Read as article” toggle
*/
(function(){
  function clamp(n, a, b){ return Math.max(a, Math.min(b, n)); }

  function decodeHtmlEntities(s){
    var str = String(s||'');
    if(str.indexOf('&') === -1) return str;
    try{
      var ta = document.createElement('textarea');
      ta.innerHTML = str;
      return ta.value;
    }catch(e){
      return str;
    }
  }

  function sanitizeHtml(html){
    var s = String(html||'');
    // remove <script> blocks
    s = s.replace(/<\s*script[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi,'');
    // remove on* attributes (basic safety)
    s = s.replace(/\son\w+\s*=\s*(["']).*?\1/gi,'');
    return s;
  }

  function buildDynamicSlides(root, slider){
    try{
      function tryParseFrom(sel){
        var n = root.querySelector(sel);
        if(!n) return null;
        var raw = decodeHtmlEntities(n.textContent || '').trim();
        if(!raw) return null;

        function normalizeJSON(s){
          if(!s) return s;
          // normalize common “smart” punctuation that breaks JSON
          s = s.replace(/\u00A0/g, ' '); // nbsp
          s = s.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");
          // remove trailing commas (very common when people edit by hand)
          s = s.replace(/,\s*([}\]])/g, '$1');
          return s;
        }

        // Pass 1: raw
        try{
          return JSON.parse(raw);
        }catch(e1){
          // Pass 2: normalized
          try{
            return JSON.parse(normalizeJSON(raw));
          }catch(e2){
            // Pass 3: if the JSON was stored as a JSON-encoded string, decode twice
            try{
              var once = JSON.parse(raw);
              if(typeof once === 'string'){
                return JSON.parse(normalizeJSON(once));
              }
            }catch(e3){}
            return null;
          }
        }
      }


      var data = tryParseFrom('.cnySlidesJson');
      if(!Array.isArray(data) || !data.length){
        data = tryParseFrom('.cnySlidesJsonFallback');
      }
      if(!Array.isArray(data) || !data.length) return false;
      // If JSON exists, prefer it.
      // Theme editor often keeps default/block slides in the DOM, so we must replace them.
      var force = root.hasAttribute('data-cny-force-json');
      var existing = slider.querySelectorAll('.cnySlide');
      if(existing && existing.length){
        if(!force) return false;
        for(var k=0;k<existing.length;k++){
          existing[k].parentNode && existing[k].parentNode.removeChild(existing[k]);
        }
      }
      var total = data.length;
      data.forEach(function(it, i){
        var title = (it && it.title) ? String(it.title) : ('Slide ' + (i+1));
        var body = (it && (it.bodyHtml||it.body)) ? String(it.bodyHtml||it.body) : '';
        var slide = document.createElement('div');
        slide.className = 'cnySlide';
        slide.setAttribute('data-cny-index', String(i));
        slide.innerHTML = ''
          + '<div class="cnyCard">'
          +   '<div class="cnySlideHeader">'
          +     '<div>'
          +       '<p class="cnySlideKicker"></p>'
          +       '<h3 class="cnySlideTitle"></h3>'
          +     '</div>'
          +   '</div>'
          +   '<div class="cnySlideBody rte"></div>'
          + '</div>';
        slide.querySelector('.cnySlideKicker').textContent = 'Slide ' + (i+1) + ' of ' + total;
        slide.querySelector('.cnySlideTitle').textContent = title;
        slide.querySelector('.cnySlideBody').innerHTML = sanitizeHtml(body);
        slider.appendChild(slide);
      });
      return true;
    }catch(e){ return false; }
  }

  function initOne(root){
    if(!root || root.__cnyInit) return;
    root.__cnyInit = true;

    var slider = root.querySelector('[data-cny-slider], .cnySlider');
    if(!slider) return;

    // If Slides JSON is provided, build slides dynamically.
    // When force-json is set (Liquid), this will replace the server/block slides.
    var builtFromJson = buildDynamicSlides(root, slider);

    var slides = Array.prototype.slice.call(root.querySelectorAll('.cnySlide'));
    if(!slides.length) return;

    var dotsWrap = root.querySelector('.cnyDots');
    var prevBtn = root.querySelector('[data-cny-prev]');
    var nextBtn = root.querySelector('[data-cny-next]');
    var toggleBtn = root.querySelector('[data-cny-toggle]');
    var progFill = root.querySelector('.cnyProgressFill');

    // Build dots (or rebuild if JSON changed slide count)
    if(dotsWrap){
      var needRebuild = !dotsWrap.children.length || (dotsWrap.children.length !== slides.length);
      if(needRebuild){
        dotsWrap.innerHTML = '';
        slides.forEach(function(_, i){
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cnyDot';
          b.setAttribute('aria-label', 'Go to slide ' + (i+1));
          b.addEventListener('click', function(){ scrollToIndex(i, true); });
          dotsWrap.appendChild(b);
        });
      }
    }


    function updateProgress(){
      if(!progFill) return;
      var max = slider.scrollWidth - slider.clientWidth;
      var pct = (max<=0) ? 0 : (slider.scrollLeft / max) * 100;
      pct = clamp(pct, 0, 100);
      progFill.style.width = pct.toFixed(2) + '%';
    }

    function getNearestIndex(){
      // Find slide with left edge closest to slider scrollLeft
      var left = slider.scrollLeft;
      var bestI = 0;
      var bestD = Infinity;
      for(var i=0;i<slides.length;i++){
        var d = Math.abs(slides[i].offsetLeft - left);
        if(d < bestD){ bestD = d; bestI = i; }
      }
      return bestI;
    }

    function setActive(i){
      if(dotsWrap){
        var dots = dotsWrap.querySelectorAll('.cnyDot');
        for(var k=0;k<dots.length;k++){
          if(k===i) dots[k].classList.add('isActive');
          else dots[k].classList.remove('isActive');
        }
      }
      if(prevBtn) prevBtn.disabled = (i<=0);
      if(nextBtn) nextBtn.disabled = (i>=slides.length-1);
      root.setAttribute('data-cny-index', String(i));
    }

    function safeSetScroll(left, smooth){
      try{
        // Prefer modern scrollTo options when available, fallback safely.
        if(typeof slider.scrollTo === 'function'){
          if(smooth && ('scrollBehavior' in document.documentElement.style)){
            slider.scrollTo({ left: left, behavior: 'smooth' });
          } else {
            // Some browsers only support numeric args
            try { slider.scrollTo(left, 0); }
            catch(e2){ slider.scrollLeft = left; }
          }
        } else {
          slider.scrollLeft = left;
        }
      } catch(e){
        slider.scrollLeft = left;
      }
    }

    function safeScrollLeft(x, smooth){
      x = Math.max(0, x||0);
      try{
        if(smooth && slider.scrollTo){ slider.scrollTo({ left: x, behavior: 'smooth' }); return; }
      }catch(e){}
      // fallback
      slider.scrollLeft = x;
    }

    function scrollToIndex(i, smooth){
      i = clamp(i, 0, slides.length-1);
      var x = slides[i].offsetLeft;
      safeSetScroll(x, !!smooth);
      setActive(i);
    }

    // Initial
    setActive(0);

    // Prev/Next
    if(prevBtn){
      prevBtn.addEventListener('click', function(){
        scrollToIndex(getNearestIndex()-1, true);
      });
    }
    if(nextBtn){
      nextBtn.addEventListener('click', function(){
        scrollToIndex(getNearestIndex()+1, true);
      });
    }

    // Toggle stacked mode
    if(toggleBtn){
      toggleBtn.addEventListener('click', function(){
        var stacked = root.classList.toggle('isStacked');
        toggleBtn.textContent = stacked ? 'Slide mode' : 'Read as article';
        if(!stacked) scrollToIndex(getNearestIndex(), false);
      });
    }

    // Wheel -> horizontal scroll (helps desktop feel less "frozen")
    // Use non-passive so we can preventDefault when the slider can scroll.
    slider.addEventListener('wheel', function(e){
      if(!e) return;
      // Only intercept when vertical wheel is used.
      var dy = e.deltaY || 0;
      if(Math.abs(dy) < 0.5) return;
      var canScroll = slider.scrollWidth > slider.clientWidth + 2;
      if(!canScroll) return;
      // Move horizontally with wheel
      slider.scrollLeft += dy;
      e.preventDefault();
    }, { passive: false });

    // Update active dot on scroll (throttled)
    var t = null;
    slider.addEventListener('scroll', function(){
      updateProgress();
      if(t) return;
      t = window.setTimeout(function(){
        t = null;
        setActive(getNearestIndex());
      }, 80);
    });

    // Keyboard support
    root.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); scrollToIndex(getNearestIndex()-1, true); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); scrollToIndex(getNearestIndex()+1, true); }
    });
  }

  function initAll(){
    var roots = document.querySelectorAll('[data-cny-guide]');
    for(var i=0;i<roots.length;i++) initOne(roots[i]);
  }

  
  // Shopify theme editor: re-init when a section reloads
  document.addEventListener('shopify:section:load', function(){ initAll(); });
  document.addEventListener('shopify:section:select', function(){ initAll(); });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();